import { render, staticRenderFns } from "./ranked.vue?vue&type=template&id=f4e7c000&scoped=true&"
import script from "./ranked.vue?vue&type=script&lang=js&"
export * from "./ranked.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4e7c000",
  null
  
)

export default component.exports